export default "__VITE_ASSET__qElLBp_W__"